<template>
  <div class="mLoadingContainer" v-if="flag">
    <div class="loader"></div>
  </div>

</template>

<script setup>

import {ref} from 'vue'

const flag = ref(false);

const openMask = () => {
  flag.value = true;
}

const closeMask = () => {
  flag.value = false;
}

defineExpose({
  openMask,
  closeMask
})

</script>

<style scoped lang="scss">
.mLoadingContainer {
  width: 100%;
  height: 100%;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10003;
  display: flex;
  align-items: center;
  justify-content: center;

  .loader {
    width: 1rem;
    aspect-ratio: 1;
    border-radius: 50%;
    border: 0.08rem solid #19559D;
    animation: l20-1 0.8s infinite linear alternate,
    l20-2 1.6s infinite linear;
  }

}

@keyframes l20-1 {
  0% {
    clip-path: polygon(50% 50%, 0 0, 50% 0%, 50% 0%, 50% 0%, 50% 0%, 50% 0%)
  }
  12.5% {
    clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 0%, 100% 0%, 100% 0%)
  }
  25% {
    clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 100% 100%, 100% 100%)
  }
  50% {
    clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%)
  }
  62.5% {
    clip-path: polygon(50% 50%, 100% 0, 100% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%)
  }
  75% {
    clip-path: polygon(50% 50%, 100% 100%, 100% 100%, 100% 100%, 100% 100%, 50% 100%, 0% 100%)
  }
  100% {
    clip-path: polygon(50% 50%, 50% 100%, 50% 100%, 50% 100%, 50% 100%, 50% 100%, 0% 100%)
  }
}

@keyframes l20-2 {
  0% {
    transform: scaleY(1) rotate(0deg)
  }
  49.99% {
    transform: scaleY(1) rotate(135deg)
  }
  50% {
    transform: scaleY(-1) rotate(0deg)
  }
  100% {
    transform: scaleY(-1) rotate(-135deg)
  }
}


</style>
